var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("EditModal", {
        ref: "editmodal",
        attrs: {
          availableSalutations: _vm.availableSalutations,
          allUsers: _vm.allUsers,
          groupSelector: _vm.groupSelector,
          groupCopyFunction: _vm.groupCopyFunction,
          groupSaveFunction: _vm.groupSaveFunction,
          allowNoEmailForExternalUsers: _vm.allowNoEmailForExternalUsers
        },
        scopedSlots: _vm._u(
          [
            {
              key: "editModalTitle",
              fn: function() {
                return [_vm._t("editModalTitle")]
              },
              proxy: true
            },
            {
              key: "editModalTabs",
              fn: function({ group }) {
                return [
                  _vm._t(
                    "editModalTabs",
                    function() {
                      return [
                        _c(
                          "TabSlot",
                          {
                            attrs: {
                              id: "surveys",
                              title: _vm.$t("survey.group.surveys"),
                              order: 20
                            }
                          },
                          [
                            _c("GroupSurveyEditor", { attrs: { group: group } })
                          ],
                          1
                        )
                      ]
                    },
                    { group: group }
                  )
                ]
              }
            },
            {
              key: "generalAfter",
              fn: function({ group }) {
                return [
                  _vm._t(
                    "generalAfter",
                    function() {
                      return [_c("GeneralAfter", { attrs: { group: group } })]
                    },
                    { group: group }
                  )
                ]
              }
            },
            {
              key: "userButtonsBefore",
              fn: function({ groupUser }) {
                return [
                  _vm._t("userButtonsBefore", null, { groupUser: groupUser }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-secondary",
                      on: {
                        click: function($event) {
                          return _vm.openMailUserModal(groupUser)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-at" })]
                  )
                ]
              }
            },
            {
              key: "userButtonsAfter",
              fn: function({ groupUser }) {
                return [
                  _vm._t("userButtonsAfter", null, { groupUser: groupUser })
                ]
              }
            },
            {
              key: "externalUserButtonsBefore",
              fn: function({ groupUserExternal }) {
                return [
                  _vm._t("externalUserButtonsBefore", null, {
                    groupUserExternal: groupUserExternal
                  }),
                  _vm._v(" "),
                  _c("PrintBadgeButton", {
                    attrs: {
                      groupSurveyExtensionId: _vm.group.id,
                      groupUserExternalId: groupUserExternal.id
                    }
                  }),
                  _vm._v(" "),
                  groupUserExternal.id &&
                  groupUserExternal.id !== _vm.emptyUUID()
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-secondary",
                          on: {
                            click: function($event) {
                              return _vm.openMailExternalUserModal(
                                groupUserExternal
                              )
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-at" })]
                      )
                    : _vm._e()
                ]
              }
            },
            {
              key: "externalUserButtonsAfter",
              fn: function({ groupUserExternal }) {
                return [
                  _vm._t("externalUserButtonsAfter", null, {
                    groupUserExternal: groupUserExternal
                  })
                ]
              }
            },
            {
              key: "selectedExternalUserButtonsBefore",
              fn: function({ groupUserExternals }) {
                return [
                  _vm._t("selectedExternalUserButtonsBefore", null, {
                    groupUserExternals: groupUserExternals
                  }),
                  _vm._v(" "),
                  groupUserExternals.some(
                    e => e.id && e.id.length && e.id !== _vm.emptyUUID()
                  )
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-secondary",
                          attrs: { disabled: _vm.sendingMailsToExternalUsers },
                          on: {
                            click: function($event) {
                              return _vm.sendMailExternalUsers(
                                groupUserExternals
                              )
                            }
                          }
                        },
                        [
                          _vm.sendingMailsToExternalUsers
                            ? _c("Spinner", { attrs: { small: true } })
                            : _c("i", { staticClass: "fa fa-at" })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              }
            },
            {
              key: "selectedExternalUserButtonsAfter",
              fn: function({ groupUserExternals }) {
                return [
                  _vm._t("selectedExternalUserButtonsAfter", null, {
                    groupUserExternals: groupUserExternals
                  })
                ]
              }
            },
            {
              key: "externalUserSelectModalTabs",
              fn: function() {
                return [
                  _vm._t("externalUserSelectModalTabs"),
                  _vm._v(" "),
                  _c(
                    "ExternalUserSelectModalTab",
                    {
                      attrs: {
                        id: "externalUsersSurvey",
                        title: _vm.$t(
                          "survey.group.editModal.externalUsers.selectModal.tabExternalUsers.title"
                        )
                      }
                    },
                    [_c("ExternalUserSelectTab")],
                    1
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c("EmailModal", {
        ref: "userEmailModal",
        on: { send: _vm.sendMailUser }
      }),
      _vm._v(" "),
      _c("EmailWithContactModal", {
        ref: "externalUserEmailModal",
        on: { send: _vm.sendMailExternalUser }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }